import { render, staticRenderFns } from "./ButtonUrl.vue?vue&type=template&id=31d11fd8&"
import script from "./ButtonUrl.vue?vue&type=script&lang=js&"
export * from "./ButtonUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports